import React, { useState, useEffect } from 'react';
import { Color, ColorLibraryData } from '../../types/ColorLibraryModel';

interface ColorDetailsEmptyProps {
  showButtons?: boolean;
  data?: ColorLibraryData;
  color?: Color | null;
}

const ColorDetailsEmpty: React.FC<ColorDetailsEmptyProps> = ({ showButtons = true }) => {
  const [windowWidth, setWindowWidth] = useState(1440);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    setWindowWidth(window.innerWidth);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const emptyData = {
    title: 'Please select a colour to view the colour codes',
    hexCode: '#000000',
    rgbCode: '000/000/000',
    tpxCode: '00-0000',
    coatedCode: '000',
    ralCode: '000 00 00',
    ncsCode: '0000-0000',
  };

  const palettesItems = ['Palette 1', 'Palette 2'];

  return (
    <div
      className="sticky top-[70px] min-h-[330px] w-full min-w-[264px] rounded-lg bg-white"
      style={{
        boxShadow: '0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12)',
      }}
    >
      <div className="p-6 pt-10">
        <div className="mb-6">
          <h3 className="text-lg font-light text-gray-400 lg:text-xl">{emptyData.title}</h3>
        </div>

        <div className="grid grid-cols-2 gap-4 pt-7">
          <div>
            <div className="mb-1 text-xs font-semibold text-gray-400">Pantone</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.tpxCode}</div>
            <div className="mb-1 text-xs font-semibold text-gray-400">Hex</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.hexCode}</div>
            <div className="mb-1 text-xs font-semibold text-gray-400">RAL</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.ralCode}</div>
          </div>
          <div>
            <div className="mb-1 text-xs font-semibold text-gray-400">Coated</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.coatedCode}</div>
            <div className="mb-1 text-xs font-semibold text-gray-400">RGB</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.rgbCode}</div>
            <div className="mb-1 text-xs font-semibold text-gray-400">NCS</div>
            <div className="mb-4 text-base text-gray-400">{emptyData.ncsCode}</div>
          </div>
        </div>

        {showButtons && (
          <div className="mt-6">
            {windowWidth > 1264 ? (
              // Desktop view
              <div className="flex h-11 items-center rounded-full border border-gray-300 px-3">
                <div className="w-1/2">
                  <select disabled className="w-full border-none bg-transparent text-gray-400 outline-none">
                    <option>{palettesItems[0]}</option>
                  </select>
                </div>
                <div className="mx-2 h-4 w-px bg-gray-300" />
                <div className="w-1/2 text-center text-[15px] font-semibold text-gray-400">Add to Palette</div>
              </div>
            ) : (
              // Tablet/Mobile view
              <div className="space-y-4">
                <select
                  disabled
                  className="w-full rounded border border-gray-300 bg-transparent p-3 text-center text-gray-400"
                >
                  <option>{palettesItems[0]}</option>
                </select>
                <div className="w-full rounded border border-gray-300 p-3 text-center font-semibold text-gray-400">
                  Add to Palette
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorDetailsEmpty;
